import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

const ProductsGallerySection = () => {
  const { language } = useLanguage();
  const [visibleItems, setVisibleItems] = useState(6);
  const [activeCategory, setActiveCategory] = useState('all');
  const [isIntersecting, setIsIntersecting] = useState(false);

  // Example product data - in a real application, this would come from an API or database
  const products = [
    {
      id: 1,
      title: {
        fr: 'Transport PT900 Débitmètre à Ultrasons',
        ar: 'عداد التدفق بالموجات فوق الصوتية Transport PT900',
        en: 'Transport PT900 Ultrasonic Flowmeter',
      },
      category: {
        fr: 'Débitmètres',
        ar: 'عدادات التدفق',
        en: 'Flowmeters'
      },

      description: {
        fr: 'PT900 est un débitmètre ultrasonique pour la mesure de liquides. Débitmètre portable à ultrasons non-intrusif. Idéal pour les mesures temporaires et les vérifications de process dans le secteur Pétrole, Gaz et Industrie.',
        ar: 'PT900 هو مقياس تدفق بالموجات فوق الصوتية لقياس السوائل. مقياس تدفق محمول بالموجات فوق الصوتية غير متداخل. مثالي للقياسات المؤقتة وفحوصات العمليات في قطاع النفط والغاز والصناعة.',
        en: 'PT900 is an ultrasonic flowmeter for measuring liquids. Portable non-intrusive ultrasonic flowmeter. Ideal for temporary measurements and process verifications in the Oil, Gas and Industry sector.',
      },
      image: '/images/products/pt900.jpg',
      specs: [
        { fr: 'Précision: ±1%', ar: 'الدقة: ±1%', en: 'Precision: ±1%' },
        { fr: 'Portable et robuste', ar: 'محمول ومتين', en: 'Portable and robust' },
        { fr: 'Sans contact avec le fluide', ar: 'بدون تلامس مع السائل', en: 'No contact with fluid' }
      ]
    },
    {
      id: 2,
      title: {
        fr: 'DigitalFlow GF868 Débitmètre à Ultrasons pour Gaz',
        ar: 'مقياس تدفق الغاز بالموجات فوق الصوتية DigitalFlow GF868',
        en: 'DigitalFlow GF868 Ultrasonic Gas Flowmeter'
      },
      category: {
        fr: 'Débitmètres',
        ar: 'عدادات التدفق',
        en: 'Flowmeters'
      },
      image: '/images/product-2.jpg',
      description: {
        fr: 'Digital Flow GF868 est dédié à la mesure des gaz de torche. Débitmètre à ultrasons pour la mesure précise des gaz de torche. Installation non-intrusive.',
        ar: 'Digital Flow GF868 مخصص لقياس غازات الشعلة. مقياس تدفق بالموجات فوق الصوتية للقياس الدقيق لغازات الشعلة. تركيب غير متداخل.',
        en: 'Digital Flow GF868 is dedicated to measuring flare gases. Ultrasonic flowmeter for precise measurement of flare gases. Non-intrusive installation.',
      },
      specs: [
        { fr: 'Précision: ±1-2%', ar: 'الدقة: ±1-2%', en: 'Precision: ±1-2%' },
        { fr: 'Sans pièces mobiles', ar: 'بدون أجزاء متحركة', en: 'No moving parts' },
        { fr: 'Installation clamp-on', ar: 'تركيب خارجي', en: 'Clamp-on installation' }
      ]
    },
    {
      id: 3,
      title: {
        fr: 'PanaFlow XMT1000 Débitmètre Ultrasonique',
        ar: 'مقياس تدفق بالموجات فوق الصوتية PanaFlow XMT1000',
        en: 'PanaFlow XMT1000 Ultrasonic Flowmeter',
      },
      category: {
        fr: 'Débitmètres',
        ar: 'عدادات التدفق',
        en: 'Flowmeters'
      },
      image: '/images/product-3.jpg',
      description: {
        fr: 'Panaflow XMT1000 mesure les fluides par la différence de temps de transit d\'une onde ultrasonique. XMT1000 pour la mesure précise des liquides. Idéal pour les applications Pétrole, Gaz et Industrie exigeantes.',
        ar: 'Panaflow XMT1000 يقيس السوائل بفرق زمن العبور للموجة فوق الصوتية. XMT1000 للقياس الدقيق للسوائل. مثالي لتطبيقات النفط والغاز والصناعة الصعبة.',
        en: 'Panaflow XMT1000 measures fluids by the transit time difference of an ultrasonic wave. XMT1000 for precise measurement of liquids. Ideal for demanding Oil, Gas and Industry applications.',
      },
      specs: [
        { fr: 'Précision: ±0.7%', ar: 'الدقة: ±0.7%', en: 'Precision: ±0.7%' },
        { fr: 'Certifié ATEX', ar: 'معتمد ATEX', en: 'ATEX Certified' },
        { fr: 'Multi-variables (débit, température, pression)', ar: 'متعدد المتغيرات (تدفق، حرارة، ضغط)', en: 'Multi-variable (flow, temperature, pressure)' }
      ]
    },
    {
      id: 4,
      title: {
        fr: 'XMO2 XP Analyseur de Gaz',
        ar: 'محلل الغاز XMO2 XP',
        en: 'XMO2 XP Gas Analyzer',
      },
      category: {
        fr: 'Analyseurs de Gaz',
        ar: 'محللات الغاز',
      },

      description: {
        fr: 'Analyseur de gaz robuste pour l\'analyse précise et en temps réel de la composition des gaz industriels dans les environnements difficiles du secteur Pétrole, Gaz et Industrie.',
        ar: 'محلل غاز متين للتحليل الدقيق وفي الوقت الحقيقي لتركيب الغازات الصناعية في البيئات الصعبة لقطاع النفط والغاز والصناعة.',
        en: 'Robust gas analyzer for accurate and real-time analysis of industrial gas composition in harsh environments of the Oil, Gas and Industry sector.',
      },
      image: '/images/products/xmo2-xp.jpg',
      specs: [
        { fr: 'Temps d\'analyse: 3-5 minutes', ar: 'وقت التحليل: 3-5 دقائق' },
        { fr: 'Certification Zone 1', ar: 'شهادة المنطقة 1' },
        { fr: 'Communication Modbus/HART', ar: 'اتصال Modbus/HART' }
      ]
    },
    {
      id: 5,
      title: {
        fr: 'l\'Analyseur XMTCpro',
        ar: 'محلل XMTCpro',
        en: 'XMTCpro Analyzer',
      },
      category: {
        fr: 'Analyseurs de Gaz',
        ar: 'محللات الغاز',
      },
      image: '/images/product-5.jpg',
      description: {
        fr: 'l\'Analyseur XMTCpro fonctionne avec la technologie thermal conductivity binary gas analyzer. Analyseur de gaz binaire haute performance pour la mesure précise de la composition des gaz dans les applications industrielles.',
        ar: 'محلل XMTCpro يعمل بتقنية محلل الغاز الثنائي للتوصيل الحراري. محلل غاز ثنائي عالي الأداء للقياس الدقيق لتركيب الغاز في التطبيقات الصناعية.',
        en: 'The XMTCpro Analyzer works with thermal conductivity binary gas analyzer technology. High-performance binary gas analyzer for precise measurement of gas composition in industrial applications.',
      },
      specs: [
        { fr: 'Technologie thermal conductivity', ar: 'تقنية التوصيل الحراري' },
        { fr: 'Analyse binaire haute précision', ar: 'تحليل ثنائي عالي الدقة' },
        { fr: 'Temps de réponse rapide', ar: 'وقت استجابة سريع' }
      ]
    },
    {
      id: 6,
      title: {
        fr: 'Moisture IQ Analyseur d\'Humidité',
        ar: 'محلل الرطوبة Moisture IQ',
        en: 'Moisture IQ Humidity Analyzer',
      },
      category: {
        fr: 'Analyseurs d\'Humidité',
        ar: 'محللات الرطوبة',
      },

      description: {
        fr: 'Analyseur d\'humidité avancé pour une mesure précise du point de rosée dans les gaz industriels du secteur Pétrole, Gaz et Industrie. Technologie robuste pour les environnements difficiles.',
        ar: 'محلل رطوبة متقدم لقياس دقيق لنقطة الندى في الغازات الصناعية لقطاع النفط والغاز والصناعة. تقنية متينة للبيئات الصعبة.',
        en: 'Advanced moisture analyzer for accurate dew point measurement in industrial gases in the Oil, Gas and Industry sector. Robust technology for harsh environments.',
      },
      image: '/images/products/moisture-iq.jpg',
      specs: [
        { fr: 'Plage de mesure: -110°C à +20°C', ar: 'نطاق القياس: -110°C إلى +20°C' },
        { fr: 'Précision: ±2°C point de rosée', ar: 'الدقة: ±2°C نقطة الندى' },
        { fr: 'Certification ATEX/IECEx', ar: 'شهادة ATEX/IECEx' }
      ]
    },
    {
      id: 7,
      title: {
        fr: 'Système de Surveillance PanaView',
        ar: 'نظام المراقبة PanaView',
      },
      category: {
        fr: 'Systèmes de Surveillance',
        ar: 'أنظمة المراقبة',
      },
      image: '/images/product-7.jpg',
      description: {
        fr: 'Plateforme logicielle intégrée pour la surveillance en temps réel des paramètres critiques des processus industriels.',
        ar: 'منصة برمجية متكاملة للمراقبة في الوقت الحقيقي للمعلمات الحرجة في العمليات الصناعية.',
      },
      specs: [
        { fr: 'Interface utilisateur intuitive', ar: 'واجهة مستخدم بديهية' },
        { fr: 'Visualisation de données avancée', ar: 'تصور متقدم للبيانات' },
        { fr: 'Alertes et notifications configurables', ar: 'تنبيهات وإشعارات قابلة للتخصيص' }
      ]
    },
    {
      id: 8,
      title: {
        fr: 'Transmetteur Multiparamètres PMT',
        ar: 'جهاز إرسال متعدد المعلمات PMT',
      },
      category: {
        fr: 'Systèmes de Surveillance',
        ar: 'أنظمة المراقبة',
      },
      image: '/images/product-8.jpg',
      description: {
        fr: 'Transmetteur intelligent pour l\'acquisition et le traitement des données de multiples capteurs industriels.',
        ar: 'جهاز إرسال ذكي لاكتساب ومعالجة البيانات من مستشعرات صناعية متعددة.',
      },
      specs: [
        { fr: 'Jusqu\'à 8 entrées capteurs', ar: 'حتى 8 مداخل للمستشعرات' },
        { fr: 'Communication HART/Modbus/Profibus', ar: 'اتصال HART/Modbus/Profibus' },
        { fr: 'Boîtier antidéflagrant', ar: 'علبة مضادة للانفجار' }
      ]
    }
  ];

  // Get unique categories
  const categories = [
    { id: 'all', name: { fr: 'Tous', ar: 'الكل' } },
    ...Array.from(
      new Set(products.map(product => product.category.fr))
    ).map(category => ({
      id: category.toLowerCase().replace(/\s+/g, '-'),
      name: {
        fr: category,
        ar: products.find(p => p.category.fr === category)?.category.ar || category
      }
    }))
  ];

  // Filter products based on active category
  const filteredProducts = activeCategory === 'all'
    ? products
    : products.filter(product => 
        product.category.fr.toLowerCase().replace(/\s+/g, '-') === activeCategory);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsIntersecting(true);
        }
      },
      { threshold: 0.1 }
    );

    const section = document.querySelector('.products-gallery-section');
    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <section className="products-gallery-section section section-light" style={{
      padding: '5rem 0',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Decorative elements */}
      <div style={{
        position: 'absolute',
        top: '5%',
        right: '-10%',
        width: '400px',
        height: '400px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.03) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>

      <div style={{
        position: 'absolute',
        bottom: '10%',
        left: '-5%',
        width: '300px',
        height: '300px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.03) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>

      <div className="container" style={{ 
        position: 'relative',
        zIndex: 2,
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '0 2rem'
      }}>
        <div style={{
          textAlign: 'center',
          marginBottom: '3rem'
        }}>
          <span style={{
            display: 'inline-block',
            padding: '0.5rem 1.5rem',
            backgroundColor: 'rgba(255, 107, 0, 0.1)',
            color: 'var(--assco-orange)',
            borderRadius: '30px',
            fontWeight: '600',
            fontSize: '0.875rem',
            marginBottom: '1rem',
            textTransform: 'uppercase'
          }}>
            {language === 'fr' ? 'Catalogue de Produits' : 
             language === 'ar' ? 'كتالوج المنتجات' : 
             'Product Catalog'}
          </span>

          <h2 style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            marginBottom: '1.5rem',
            color: '#1a202c',
            position: 'relative',
            display: 'inline-block'
          }}>
            {language === 'fr' ? 'Solutions d\'Instrumentation Avancées' : 
             language === 'ar' ? 'حلول القياس المتقدمة' : 
             'Advanced Instrumentation Solutions'}
            <span style={{
              position: 'absolute',
              bottom: '-10px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '80px',
              height: '4px',
              backgroundColor: 'var(--assco-orange)',
              borderRadius: '2px'
            }}></span>
          </h2>
          <p style={{
            fontSize: '1.125rem',
            color: '#4a5568',
            maxWidth: '700px',
            margin: '0 auto',
            lineHeight: '1.7'
          }}>
            {language === 'fr' 
              ? 'Découvrez notre gamme complète d\'instruments de haute précision pour les mesures industrielles, conçus pour les environnements les plus exigeants.' 
              : language === 'ar'
              ? 'اكتشف مجموعتنا الكاملة من أدوات القياس عالية الدقة للقياسات الصناعية، المصممة لأكثر البيئات تطلباً.'
              : 'Discover our complete range of high-precision instruments for industrial measurements, designed for the most demanding environments.'}
          </p>
        </div>

        {/* Categories Filter */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: '0.75rem',
          marginBottom: '3rem'
        }}>
          {categories.map(category => (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              style={{
                padding: '0.75rem 1.5rem',
                borderRadius: '30px',
                border: 'none',
                backgroundColor: activeCategory === category.id ? 'var(--assco-orange)' : '#e2e8f0',
                color: activeCategory === category.id ? 'white' : '#4a5568',
                fontWeight: '600',
                fontSize: '0.95rem',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
              }}
              onMouseOver={(e) => {
                if (activeCategory !== category.id) {
                  e.currentTarget.style.backgroundColor = '#cbd5e0';
                }
              }}
              onMouseOut={(e) => {
                if (activeCategory !== category.id) {
                  e.currentTarget.style.backgroundColor = '#e2e8f0';
                }
              }}
            >
              {language === 'fr' ? category.name.fr : 
               language === 'ar' ? category.name.ar : 
               category.name.en}
            </button>
          ))}
        </div>

        {/* Products Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(min(320px, 100%), 1fr))',
          gap: '2rem',
          opacity: isIntersecting ? 1 : 0,
          transform: `translateY(${isIntersecting ? '0' : '30px'})`,
          transition: 'opacity 0.6s ease, transform 0.6s ease',
        }}>
          {filteredProducts.slice(0, visibleItems).map((product, index) => (
            <div 
              key={product.id} 
              style={{
                backgroundColor: 'white',
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06)',
                border: '1px solid #edf2f7',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                opacity: isIntersecting ? 1 : 0,
                transform: isIntersecting ? 'translateY(0)' : 'translateY(30px)',
                animationDelay: `${index * 0.1}s`,
                animationDuration: '0.6s',
                animationFillMode: 'forwards'
              }}
              className="product-card"
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.1)';
                e.currentTarget.style.borderColor = 'rgba(255, 107, 0, 0.2)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.06)';
                e.currentTarget.style.borderColor = '#edf2f7';
              }}
            >
              {/* Product Image */}
              <div style={{
                height: '200px',
                overflow: 'hidden',
                position: 'relative',
                backgroundColor: '#f8fafc',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                {/* Placeholder for image - use actual product images in production */}
                <div style={{
                  backgroundColor: `hsl(${(product.id * 40) % 360}, 80%, 97%)`,
                  height: '100%',
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative'
                }}>
                  <div style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3z' fill='%23FF6B00' fill-opacity='0.05' fill-rule='evenodd'/%3E%3C/svg%3E")`,
                    opacity: 0.8
                  }}></div>

                  <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '80px', height: '80px', color: `hsl(${(product.id * 40) % 360}, 80%, 70%)` }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    {product.category.fr === 'Débitmètres' && (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                    )}
                    {product.category.fr === 'Analyseurs de Gaz' && (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    )}
                    {product.category.fr === 'Analyseurs d\'Humidité' && (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                    )}
                    {product.category.fr === 'Systèmes de Surveillance' && (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                    )}
                  </svg>
                </div>

                <div style={{
                  position: 'absolute',
                  top: '1rem',
                  right: '1rem',
                  backgroundColor: 'var(--assco-orange)',
                  color: 'white',
                  padding: '0.4rem 0.75rem',
                  borderRadius: '20px',
                  fontSize: '0.75rem',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }}>
                  {language === 'fr' ? product.category.fr : 
                   language === 'ar' ? product.category.ar : 
                   product.category.en}
                </div>
              </div>
              
              {/* Product Content */}
              <div style={{
                padding: '1.75rem'
              }}>
                <h3 style={{
                  fontSize: '1.25rem',
                  fontWeight: '700',
                  marginBottom: '1rem',
                  color: '#1a202c',
                  lineHeight: '1.4',
                  minHeight: '3.5rem',
                  display: '-webkit-box',
                  WebkitLineClamp: '2',
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}>
                  {language === 'fr' ? product.title.fr : 
                   language === 'ar' ? product.title.ar : 
                   product.title.en}
                </h3>
                <p style={{
                  fontSize: '0.95rem',
                  color: '#4a5568',
                  marginBottom: '1.5rem',
                  lineHeight: '1.6'
                }}>
                  {language === 'fr' ? product.description.fr : 
                   language === 'ar' ? product.description.ar : 
                   product.description.en}
                </p>
                
                {/* Specifications */}
                <div style={{
                  marginBottom: '1.75rem',
                  padding: '1rem',
                  backgroundColor: '#f8fafc',
                  borderRadius: '8px',
                  border: '1px solid #edf2f7'
                }}>
                  <h4 style={{
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    color: '#4a5568',
                    marginBottom: '0.75rem'
                  }}>
                    {language === 'fr' ? 'Caractéristiques clés:' : 
                     language === 'ar' ? 'الميزات الرئيسية:' : 
                     'Key Features:'}
                  </h4>
                  <ul style={{
                    listStyleType: 'none',
                    padding: '0',
                    margin: '0'
                  }}>
                    {product.specs.map((spec, idx) => (
                      <li key={idx} style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: idx < product.specs.length - 1 ? '0.5rem' : '0',
                        fontSize: '0.875rem',
                        color: '#4a5568'
                      }}>
                        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '14px', height: '14px', marginRight: '0.5rem', color: 'var(--assco-orange)' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        {language === 'fr' ? spec.fr : 
                         language === 'ar' ? spec.ar : 
                         spec.en}
                      </li>
                    ))}
                  </ul>
                </div>
                
              </div>
            </div>
          ))}
        </div>

        {/* Load More Button */}
        {filteredProducts.length > visibleItems && (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '3rem'
          }}>
            <button 
              onClick={() => setVisibleItems(prevCount => prevCount + 4)}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.75rem',
                backgroundColor: 'white',
                color: '#1a202c',
                padding: '0.75rem 2rem',
                borderRadius: '30px',
                fontWeight: '600',
                fontSize: '1rem',
                border: '2px solid #e2e8f0',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#f7fafc';
                e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.1)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = 'white';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.05)';
              }}
            >
              {language === 'fr' ? 'Charger plus de produits' : 
               language === 'ar' ? 'تحميل المزيد من المنتجات' : 
               'Load more products'}
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="16" 
                height="16" 
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
          </div>
        )}
      </div>

      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .product-card {
          animation-name: fadeInUp;
        }
      `}</style>
    </section>
  );
};

export default ProductsGallerySection;
